// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getMessaging } from "firebase/messaging/sw"
import { getToken } from "firebase/messaging"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
}
// Initialize Firebase
// const app = initializeApp(firebaseConfig)

let analytics
let auth
let firestore
let messaging
if (firebaseConfig?.projectId) {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig)

  if (app.name && typeof window !== "undefined") {
    analytics = getAnalytics(app)
    auth = getAuth(app)

    messaging = getMessaging(app)
  }
  // Access Firebase services using shorthand notation
  firestore = getFirestore()
}
export { auth, analytics, firestore, messaging }
// export default app

export const fetchToken = async () => {
  const serviceWorkerRegistration = getOrRegisterServiceWorker()

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration
    })

    if (currentToken) {
      return currentToken
    } else {
      console.log("No registration token available. Request permission to generate one.")
      return null
    }
  } catch (err) {
    const error =
      "AbortError: Failed to execute 'subscribe' on 'PushManager': Subscription failed - no active Service Worker"
    if (err.toString() === error) {
      return await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration
      })
    } else {
      console.log("An error occurred while retrieving token. ", err)
      return null
    }
  }
}

const getOrRegisterServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(function (registration) {
        // Use the serviceWorker.ready promise to ensure the service worker is active
        navigator.serviceWorker.ready.then(function (registration) {
          console.log("Service Worker Registered and Active")
          // Proceed to subscribe to push notifications
        })
      })
      .catch(function (error) {
        console.error("Service Worker registration failed:", error)
      })
  } else throw new Error("The browser doesn`t support service worker.")
}
